import basePath from "base_path";

import ActionTypes, {MattersActionTypes} from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {CollectionTypeNames, FileItem, Matter} from "common/types/matter";

export type MatterCreateAction = {
  type: MattersActionTypes["MATTER_CREATE"]["SUCCESS"];
  payload: Matter;
};

export default function createMatter(requestor) {
  return createReduxPromiseAction(
    ActionTypes.MATTER_CREATE,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      name: string,
      fileItems: FileItem[],
      collectionTypeNames: CollectionTypeNames,
      context?: string,
      clientContextId?: number | null,
      isProjectContextDisabled?: boolean,
    ) => {
      const formData = new FormData();
      formData.append("name", name);
      formData.append(
        "collectionTypeNames",
        JSON.stringify(collectionTypeNames),
      );

      // Sent with the upload so the family setting is stored, and copied onto
      // the new documents, before the analysis jobs are queued.
      if (context !== undefined) {
        formData.append("context", context);
        formData.append(
          "clientContextId",
          clientContextId === null || clientContextId === undefined
            ? ""
            : String(clientContextId),
        );
        formData.append(
          "isProjectContextDisabled",
          String(Boolean(isProjectContextDisabled)),
        );
      }

      const metadata = fileItems.map((item, index) => {
        const fileField = `file_${index}`;
        formData.append(fileField, item.file);

        return {
          fileField,
          documentType: item.documentType,
          documentGroup: item.documentGroup,
        };
      });

      formData.append("fileItems", JSON.stringify(metadata));

      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/project/${projectId}/matter`,
          formData,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
